// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-o_gC","galleryThumbnail_active":"c-o_gE","galleryThumbnail__image":"c-o_gF","galleryThumbnail__image_withBlur":"c-o_gG"};